import type { StatisticItemProps } from './statistic-item.interface';
import type { FC } from 'react';

import React from 'react';
import { Link } from 'react-router';

export const StatisticItem: FC<StatisticItemProps> = ({
  title,
  number,
  link,
}: StatisticItemProps) => (
  <Link className={'statistic-item'} to={link}>
    <div className={'statistic-item__name'}>{title}</div> Anzahl{' '}
    <span className={'statistic-item__number'}>{number}</span>
  </Link>
);
